import React, { useState } from 'react';
import { HiOutlineEye, HiOutlineEyeOff, HiOutlineLockClosed, HiOutlineUser } from 'react-icons/hi';
import './Login.css';
import { supabase } from '../supabaseClient';

function Login({ onLogin }) {
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [focusedInput, setFocusedInput] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email: credentials.email,
        password: credentials.password,
      });

      if (error) {
        setError(error.message || 'Email ou mot de passe incorrect');
        setIsLoading(false);
        return;
      }

      // Check if user exists in admin_users table
      const { data: adminUser, error: adminError } = await supabase
        .from('admin_users')
        .select('role')
        .eq('email', credentials.email)
        .single();

      if (adminError || !adminUser) {
        setError('Accès non autorisé. Seuls les administrateurs peuvent se connecter.');
        await supabase.auth.signOut();
        setIsLoading(false);
        return;
      }

      // Check if user has admin role
      if (adminUser.role !== 'admin') {
        setError('Accès non autorisé. Seuls les administrateurs peuvent se connecter.');
        await supabase.auth.signOut();
        setIsLoading(false);
        return;
      }

      setIsLoading(false);
      onLogin(true);
    } catch (error) {
      console.error('Login error:', error);
      setError('Erreur de connexion. Veuillez réessayer.');
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleInputFocus = (e) => {
    setFocusedInput(e.target.name);
  };

  const handleInputBlur = () => {
    setFocusedInput('');
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            {/* <HiOutlineLockClosed className="login-icon" /> */}
            <h1>Administration</h1>
            <p>Connectez-vous pour accéder au panneau d'administration</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">Adresse email</label>
              <div className="input-wrapper">
                {focusedInput !== 'email' && <HiOutlineUser className="input-icon" />}
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={credentials.email}
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  onBlur={handleInputBlur}
                  placeholder=""
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="password">Mot de passe</label>
              <div className="input-wrapper">
                {/* {focusedInput !== 'password' && <HiOutlineLockClosed className="input-icon" />} */}
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={credentials.password}
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  onBlur={handleInputBlur}
                  placeholder="Entrez votre mot de passe"
                  required
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <HiOutlineEyeOff /> : <HiOutlineEye />}
                </button>
              </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            <button
              type="submit"
              className={`login-btn ${isLoading ? 'loading' : ''}`}
              disabled={isLoading}
            >
              {isLoading ? 'Connexion en cours...' : 'Se connecter'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;

